import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  CustomInput,
  FormFeedback,
} from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { CustomRadioBtn } from '../../../../UI/CustomForm';
import { remove } from 'lodash';
import { Input, Checkbox, Alert, Button, Loading } from '../../../../UI/Common';
import Required from '../../../../UI/Required';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import helper from '../../../../../utils/helper';
import ReactSelect from '../../../../UI/ReactSelect';

const _period = [
  { value: 'DAY', label: 'Day' },
  { value: 'WEEK', label: 'Week' },
  { value: 'MONTH', label: 'Month' },
];
const EditScheduledReportPage = (props) => {
  //prettier-ignore
  const { t, isSubmitting, groups, sensorTypes, getScheduledReportError, scheduledReport={} } = props;
  const [form, setForm] = React.useState({
    enabled: false,
    reportName: '',
    emailList: '',
    period: '',
    groupId: '',
    typeIds: [],
  });
  const [openModal, setOpenModal] = React.useState(false);
  React.useEffect(() => {
    if (form.groupId) {
      props.onChangeGroup(form.groupId);
    }
  }, [form.groupId]);
  if (Object.keys(getScheduledReportError).length) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This scheduled report is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  if (!Object.keys(scheduledReport).length) {
    return (
      <Backend>
        <div className="content-inner">
          <Loading />
        </div>
      </Backend>
    );
  }
  const onChangeGroup = (v, setFieldTouched, setFieldValue) => {
    const { value } = v;
    setFieldTouched('groupId', false);
    setFieldValue('groupId', value);
    setFieldValue('typeIds', []);
    setForm({
      ...form,
      groupId: value,
    });
  };
  const selectSensorType = (e, sensorType, typeIds, setFieldValue) => {
    if (e.target.checked) {
      if (!typeIds.find((typeId) => typeId === sensorType.id)) {
        typeIds.push(sensorType.id);
        setFieldValue('typeIds', typeIds);
      }
    } else {
      if (typeIds.find((typeId) => typeId === sensorType.id)) {
        remove(typeIds, (typeId) => typeId === sensorType.id);
        setFieldValue('typeIds', typeIds);
      }
    }
  };
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onEditScheduledReport(values);
    }
  }
  return (
    <Backend
      title={`Edit Scheduled Report: ${scheduledReport.reportName || ''}`}
    >
      <div className="content-inner">
        <Formik
          enableReinitialize
          initialValues={scheduledReport}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <PasswordConfirmation
                  isOpen={openModal}
                  onCancel={() => setOpenModal(false)}
                  onConfirm={() => {
                    setOpenModal(false);
                    props.onEditScheduledReport(values);
                  }}
                />
                <Row>
                  <Col>
                    <Checkbox
                      id="enable"
                      label="Enabled"
                      checked={values.enable}
                      onChange={(isCheck) => setFieldValue('enable', isCheck)}
                    />
                    <Input
                      required
                      label="Report Name"
                      id="reportName"
                      onChange={handleChange('reportName')}
                      invalid={errors.reportName && touched.reportName}
                      value={values.reportName}
                      error={errors.reportName}
                    />
                    <Input
                      required
                      type="textarea"
                      inputClass="custom-text-area"
                      label="Email List"
                      id="emailList"
                      helperText="Please enter emails in each line"
                      onChange={handleChange('emailList')}
                      invalid={errors.emailList && touched.emailList}
                      value={values.emailList}
                      error={errors.emailList}
                    />
                    <CustomRadioBtn
                      required
                      id="period"
                      label="Period"
                      data={_period}
                      value={values.period}
                      valueKey="value"
                      labelKey="label"
                      onChange={(p) => setFieldValue('period', p)}
                      invalid={touched.period && errors.period}
                      error={errors.period}
                    />
                  </Col>
                  <Col>
                    <ReactSelect
                      label="Group"
                      options={groups}
                      value={values.groupId}
                      onChange={(v) =>
                        onChangeGroup(v, setFieldTouched, setFieldValue)
                      }
                      valueKey="id"
                      labelKey="name"
                      invalid={touched.groupId}
                      error={errors.groupId}
                    />
                    <FormGroup>
                      <Label>
                        {t('Sensor Types')} <Required />
                      </Label>
                      <div>
                        {sensorTypes.map((sensorType) => (
                          <CustomInput
                            key={sensorType.id}
                            type="checkbox"
                            id={sensorType.id}
                            label={sensorType.typeName}
                            checked={values.typeIds.includes(sensorType.id)}
                            onChange={(e) =>
                              selectSensorType(
                                e,
                                sensorType,
                                values.typeIds,
                                setFieldValue,
                              )
                            }
                          />
                        ))}
                      </div>
                      {touched.typeIds && errors.typeIds && (
                        <FormFeedback>{t(errors.typeIds)}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Alert.Error text={props.errors} />
                <Button
                  id="edit-scheduled-report-btn"
                  classes="mt-20"
                  loading={isSubmitting}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <i className="md-icon">done</i>
                  {t('Save')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(EditScheduledReportPage);
